<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">      
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>会员</el-breadcrumb-item>
          <el-breadcrumb-item>会员注册</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-steps :active="activeStep" simple>
          <el-step title="信息登记" icon="el-icon-edit"></el-step>
          <el-step title="开通VIP" icon="el-icon-upload"></el-step>
        </el-steps>
        <el-card v-if="activeStep==0">
          <div slot="header" class="clearfix">
          </div>
          <el-form ref="form" v-model="member" size="medium"  label-width="100px">
            <el-col :span="11">
              <el-form-item label="会员名称">
                <el-input v-model="member.name" ></el-input>
              </el-form-item>    
            </el-col>  
            <el-col :span="11">
              <el-form-item label="联系电话">
                <el-input v-model="member.mobile"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="密码">
                <el-input v-model="member.password" show-password></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="确认密码">
                <el-input v-model="member.password2" show-password></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="性别">
                <el-radio-group v-model="member.gender">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="生日">
                <el-date-picker
                  v-model="member.birthday"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>   
            </el-col>     
            <el-col :span="11">      
              <el-form-item label="推介人编号">
                <el-input v-model="member.recommendNO"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" >      
              <el-form-item label-width="200px">
                <el-button type="primary" @click="SaveMember">立即注册</el-button>
              </el-form-item>
            </el-col> 
          </el-form>
        </el-card>
        <el-card v-if="activeStep==1">
          <el-form label-width="100px" @submit.native.prevent>      
              <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="激活VIP" name="first">
                  <el-form-item label="请输入验证码">
                    <el-col :span="12">
                      <el-input v-model="code">
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-row class="top10 center">              
                    <el-button type="success">确定</el-button>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="购买VIP" name="second">
                  <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @row-click="handleClick">
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>               
                    <el-table-column
                      prop="Name"
                      label="标题">
                    </el-table-column>
                    <el-table-column
                      prop="SoldMoney"
                      label="价格"
                      width="100"
                      show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      prop="ValidityDays"
                      label="有效期"
                      width="100"
                      show-overflow-tooltip>
                    </el-table-column>
                  </el-table>
                  
                  <el-form-item class="top10">
                    <el-button type="warning" plain @click="selectPayType(1)" >现金支付{{CashPaid}}元</el-button>
                    <el-button type="success" plain @click="selectPayType(2)" >微信/支付宝{{ThirdPaid}}元</el-button>
                    <el-button type="primary" plain @click="selectPayType(3)" >其他支付{{OtherPaid}}元</el-button>
                  </el-form-item>
                  <el-row class="top10 center"  >              
                    <el-button type="success"  >结算</el-button>
                  </el-row>
                </el-tab-pane>
              </el-tabs>              
          </el-form>   
        </el-card>
      </div>
      <GetPayCode v-bind:dialogPayCode="dialogPayCode" @UpdatePayCode="UpdatePayCode"></GetPayCode>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import GetPayCode from '@/components/GetPayCode'
  export default {
    props:{
    },
    data (){
      return {
        activeStep:0,
        member:{
          id:'',
          name:'',
          mobile:'',
          password:'',
          password2:'',
          gender:0,
          birthday:'',
          recommendNO:''
        },
        code:'',
        tableData:[],        
        selectRule:{},
        activeName:'first',
        payType:0,
        SoldMoney:0,        
        dialogPayCode: {
          isShow:false
        },
      }
    },
    computed:{
      CashPaid:function(){
        if(this.payType==1)
          return this.SoldMoney
        else 
          return 0
      },
      ThirdPaid:function(){
        if(this.payType==2)
          return this.SoldMoney
        else 
          return 0
      },
      OtherPaid:function(){
        if(this.payType==3)
          return this.SoldMoney
        else 
          return 0
      }
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/MemberCard/Index',
        params:{
          name : '',
          pageIndex : 1,
          pagesize : 100,
          sort : ' SoldMoney asc'
        }
      }).then(function (resp) {
        that.tableData = resp.data.memberCards
      }).catch(resp => {
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },
    methods:{     
      SaveMember:function(){
        var that = this
        if(this.member.password != this.member.password2){
          that.$message({
            showClose: true,
            message: '请输入相同的密码!',
            type: 'warning'
          });
          return
        }
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Member/Register',         
          data:{
            Name:that.member.name,
            Mobile : that.member.mobile,
            Password : that.member.password,
            Gender : that.member.gender,
            RecommendNO : that.member.recommendNO,
            Birthday : that.member.birthday,
          }
        }).then(function (resp) {
          if(resp.data.errorCode==0){   
            that.activeStep = 1;
            that.member.id = resp.data.id
          }else {
            that.$message({
              showClose: true,
              message: resp.data.message,
              type: 'warning'
            });
          }
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      selectPayType(val){
        this.payType = val
      },      
      handleClick(row){
        if (row) {
          this.$refs.multipleTable.clearSelection();
          this.$refs.multipleTable.toggleRowSelection(row);
          this.selectRule = row
          this.SoldMoney = this.selectRule.SoldMoney
        }else {
          this.selectRule = {}
        }
      },      
      UpdatePayCode(code){
        this.recharge.paidInfo.PayCode = code
        this.SubmitRecharge()
      },
      BuyCard:function(){
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/Member/ExchangeCard',         
            data:{
              MemberId:that.member.id,
              CardId : that.selectRule.Id,
              PayType : that.payType,
              Memo : that.business.Memo
            }
          }).then(function (resp) {
            if(resp.data.errorCode==0){   
              that.activeStep = 2;
            }else {
              that.$message({
                showClose: true,
                message: resp.data.message,
                type: 'warning'
              });
            }
          }).catch(resp => {          
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
      }
    },
    components:{    
      GetPayCode
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.top10{
  margin-top 10px;
}
</style>